import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { loyaltyAllocationReversalAPI } from 'api/loyalty'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  LoyaltyAllocationReversalTxFormTypes,
  LoyaltyAllocationReversalTxFormSubmitValuesTypes,
  LoyaltyAllocationReversalTxFormSubmitActionsTypes,
} from 'types/loyaltyAllocationReversalTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const LOYALTYREDEMPTIONTXINITVAL: LoyaltyAllocationReversalTxFormTypes = {
  externalTransactionId: '',
  ident: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
  // storeId: 0,
}

export const useLoyaltyAllocationReversalTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: LoyaltyAllocationReversalTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitLoyaltyAllocationReversalTx: (
    values: LoyaltyAllocationReversalTxFormSubmitValuesTypes,
    actions: LoyaltyAllocationReversalTxFormSubmitActionsTypes
  ) => void
  handleClearLoyaltyAllocationReversalTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<LoyaltyAllocationReversalTxFormTypes>({
      ...LOYALTYREDEMPTIONTXINITVAL,
      // externalTransactionId: Number(member?.traderId) || 0,
      externalTransactionId: '',
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitLoyaltyAllocationReversalTx = useCallback(
    async (
      values: LoyaltyAllocationReversalTxFormSubmitValuesTypes,
      actions: LoyaltyAllocationReversalTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        await loyaltyAllocationReversalAPI(values)
        toast.success('Loyalty allocation reversal successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`ERR: ${message.outcomeUserMessage}`)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearLoyaltyAllocationReversalTx = useCallback(() => {
    initialValuesSet({ ...LOYALTYREDEMPTIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitLoyaltyAllocationReversalTx,
    handleClearLoyaltyAllocationReversalTx,
  }
}
